import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { Loader } from '../../components/Loader'
import toast from 'react-hot-toast'

/**
 * ورود با «لینک اختصاصی» که مدیر برای کاربر ساخته و ارسال کرده است.
 * ساختار لینک: /login-link?token=...
 */
const LoginLink: React.FC = () => {
  const { loginWithLink } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const tried = useRef(false)

  const [status, setStatus] = useState<'loading' | 'error' | 'done'>('loading')
  const [error, setError] = useState('')

  useEffect(() => {
    if (tried.current) return
    tried.current = true

    if (!token) {
      setStatus('error')
      setError('لینک ورود ناقص است؛ لطفاً از مدیر بخواهید لینک جدیدی برای شما ارسال کند.')
      return
    }

    const run = async () => {
      try {
        await loginWithLink(token)
        setStatus('done')
        toast.success('خوش آمدید 👋')
        setTimeout(() => navigate('/', { replace: true }), 900)
      } catch (err: any) {
        setStatus('error')
        setError(err?.response?.data?.message || err.message || 'لینک ورود نامعتبر یا منقضی شده است.')
      }
    }

    run()
  }, [token, loginWithLink, navigate])

  return (
    <div className="container-main flex justify-center py-14">
      <div className="w-full max-w-md">
        <div className="card p-8 text-center">
          {status === 'loading' && (
            <>
              <div className="flex justify-center mb-4"><Loader /></div>
              <h1 className="text-lg font-black text-gray-900 mb-1">در حال ورود…</h1>
              <p className="text-sm text-gray-500">لطفاً چند لحظه صبر کنید</p>
            </>
          )}

          {status === 'done' && (
            <>
              <div className="text-4xl mb-3">✅</div>
              <h1 className="text-lg font-black text-gray-900 mb-1">ورود موفق</h1>
              <p className="text-sm text-gray-500">در حال انتقال به فروشگاه…</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="text-4xl mb-3">⚠️</div>
              <h1 className="text-lg font-black text-gray-900 mb-1">ورود با لینک ممکن نشد</h1>
              <p className="text-sm text-gray-500 mb-6">{error}</p>
              <div className="space-y-2">
                <Link to="/login" className="btn btn-primary w-full !py-3">ورود با ایمیل و رمز عبور</Link>
                <Link to="/" className="btn btn-secondary w-full !py-3">بازگشت به فروشگاه</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default LoginLink